export const MEDIA_TYPES = [
  { label: 'Scripts', value: 'script' },
  { label: 'Transcripts', value: 'transcript' },
  { label: 'Audio Files', value: 'audio' },
  { label: 'Video Files', value: 'video' }
] as const;

export const CONTENT_CATEGORIES = [
  { label: 'Movies', value: 'movie' },
  { label: 'TV Shows', value: 'tv_show' },
  { label: 'Podcasts', value: 'podcast' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Other', value: 'other' }
] as const;

export const ANALYSIS_TEMPLATES = [
  { label: 'Character Archetypes', value: 'archetypes' },
  { label: 'Thematic Analysis', value: 'themes' },
  { label: 'Representation Gaps', value: 'representation' },
  { label: 'Sentiment Analysis', value: 'sentiment' }
] as const;

export const REPORT_TEMPLATES = [
  {
    id: 'summary',
    name: 'Executive Summary',
    description: 'High-level findings and key insights',
    sections: ['methodology', 'key_findings', 'recommendations']
  },
  {
    id: 'detailed',
    name: 'Detailed Analysis',
    description: 'Comprehensive analysis with all data',
    sections: ['methodology', 'data_overview', 'detailed_findings', 'analysis', 'recommendations', 'appendix']
  },
  {
    id: 'thematic',
    name: 'Thematic Analysis',
    description: 'Focus on themes and narrative elements',
    sections: ['methodology', 'theme_analysis', 'character_analysis', 'narrative_patterns']
  },
  {
    id: 'representation',
    name: 'Representation Analysis',
    description: 'Focus on demographic representation',
    sections: ['methodology', 'demographic_breakdown', 'representation_gaps', 'recommendations']
  }
] as const;

export const COLORS = {
  primary: '#722ed1',
  secondary: '#9254de',
  success: '#52c41a',
  warning: '#fa8c16',
  error: '#f5222d',
  info: '#1890ff'
} as const;

export const QUICK_QUESTIONS = [
  "What are the main themes in this study?",
  "Analyze character representation gaps",
  "Show sentiment analysis over time",
  "What archetypes are most common?",
  "Compare representation across media types",
  "Identify narrative patterns"
] as const;

export const FILE_UPLOAD_CONFIG = {
  maxSize: 100 * 1024 * 1024, // 100MB
  acceptedTypes: ['.txt', '.docx', '.pdf', '.mp3', '.mp4', '.wav', '.m4a', '.epub', '.mobi'], // Added ebook formats
  maxFiles: 50
} as const; 